import { render, staticRenderFns } from "./Public.vue?vue&type=template&id=851a8a24&scoped=true&"
import script from "./Public.vue?vue&type=script&lang=js&"
export * from "./Public.vue?vue&type=script&lang=js&"
import style0 from "./Public.vue?vue&type=style&index=0&id=851a8a24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "851a8a24",
  null
  
)

export default component.exports